import { useCallback, useEffect, useState } from 'react';

type TScrollOptions = {
    offset: number;
    parentId?: string;
    offsetDesktop?: number;
};

const DESKTOP = 768;

export const useStickyElementById = (
    elementId: string,
    { offset, parentId, offsetDesktop }: TScrollOptions
) => {
    const [isSticky, setIsSticky] = useState(false);

    const checkStickiness = useCallback(() => {
        const stickyElement = document.querySelector(`#${elementId}`);

        if (!stickyElement) return;
        const rect = stickyElement.getBoundingClientRect();

        const distance = offsetDesktop && window.innerWidth >= DESKTOP ? offsetDesktop : offset;

        if (rect.top <= distance) setIsSticky(true);
        else setIsSticky(false);
    }, [offset, offsetDesktop, elementId]);

    useEffect(() => {
        checkStickiness();
    }, [checkStickiness]);

    useEffect(() => {
        const parentEl = parentId && document.getElementById(parentId);
        const isParentScrollable = parentEl && parentEl.scrollHeight > parentEl.clientHeight;
        const container = (isParentScrollable && parentEl) || window;

        container.addEventListener('scroll', checkStickiness);
        return () => container.removeEventListener('scroll', checkStickiness);
    }, [checkStickiness, parentId]);

    return { isSticky };
};
